const state = {
	chapters: [],
	ctrStructure: [],
	dictionaryValues: {},
	chapter: {}
}

export default state
